module.exports = __webpack_public_path__ + "img/31-green.69b87611.svg";